/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetVolunteerShiftAvailabilityQueryVariables = Types.Exact<{
  event_id: Types.Scalars["Int"];
}>;

export type GetVolunteerShiftAvailabilityQuery = {
  volunteerShiftAvailability: Array<
    Pick<
      Types.VolunteerShiftAvailability,
      "shift_id" | "signup_count" | "checked_in_count"
    >
  >;
};

export const GetVolunteerShiftAvailabilityDocument = gql`
  query GetVolunteerShiftAvailability($event_id: Int!) {
    volunteerShiftAvailability(event_id: $event_id) {
      shift_id
      signup_count
      checked_in_count
    }
  }
`;

/**
 * __useGetVolunteerShiftAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetVolunteerShiftAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolunteerShiftAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolunteerShiftAvailabilityQuery({
 *   variables: {
 *      event_id: // value for 'event_id'
 *   },
 * });
 */
export function useGetVolunteerShiftAvailabilityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetVolunteerShiftAvailabilityQuery,
    GetVolunteerShiftAvailabilityQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetVolunteerShiftAvailabilityQuery,
    GetVolunteerShiftAvailabilityQueryVariables
  >(GetVolunteerShiftAvailabilityDocument, baseOptions);
}
export function useGetVolunteerShiftAvailabilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetVolunteerShiftAvailabilityQuery,
    GetVolunteerShiftAvailabilityQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetVolunteerShiftAvailabilityQuery,
    GetVolunteerShiftAvailabilityQueryVariables
  >(GetVolunteerShiftAvailabilityDocument, baseOptions);
}
export type GetVolunteerShiftAvailabilityQueryHookResult = ReturnType<
  typeof useGetVolunteerShiftAvailabilityQuery
>;
export type GetVolunteerShiftAvailabilityLazyQueryHookResult = ReturnType<
  typeof useGetVolunteerShiftAvailabilityLazyQuery
>;
export type GetVolunteerShiftAvailabilityQueryResult =
  ApolloReactCommon.QueryResult<
    GetVolunteerShiftAvailabilityQuery,
    GetVolunteerShiftAvailabilityQueryVariables
  >;
